import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";

@Directive({ standalone: false, selector: "[clickOutsideDdown]" })
export class ClickOutsideDdownDirective {
  constructor(private _elementRef: ElementRef) {}

  @Input() ignoreElements: string[] = [];
  @Output("clickOutsideDdown") clickOutsideDdown: EventEmitter<any> =
    new EventEmitter();

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    const path =
      (event.composedPath && event.composedPath()) || this.getPath(target);

    const clickedInside = path.includes(this._elementRef.nativeElement);

    if (this.ignoreElements.includes(target?.id)) {
      return;
    }

    if (!clickedInside) {
      this.clickOutsideDdown.emit(target);
    }
  }

  private getPath(element: HTMLElement): HTMLElement[] {
    const path = [];
    while (element) {
      path.push(element);
      element = element.parentElement;
    }
    path.push(document, window);
    return path;
  }
}
